import { getAnimatedButtonTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "../../shortodeAddition";

const animatedButtonConfig = (tinymce, uuid, shortcodeOnClick) => {
  const dialogData = {};

  const initialStep = {
    title: "Animated Button",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "type",
          label: "Select the type of the button",
          items: [
            { value: "call", text: "Call" },
            { value: "text", text: "Text" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "colorinput",
          name: "hoverColor",
          label: "Hover color",
        },
      ],
    },
    initialData: {
      bgColor: "#004b75",
      hoverColor: "#003452",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Next",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      dialogData.type = data.type;
      dialogData.bgColor = data.bgColor;
      dialogData.hoverColor = data.hoverColor;

      if (data.type === "call") {
        api.redial(callLinkStep);
      } else {
        api.redial(textLinkStep);
      }
    },
  };

  const callLinkStep = {
    title: "Animated Button",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "text",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
      ],
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add Button",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(initialStep);
      }
    },
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getAnimatedButtonTemplate({
        text: data.text,
        url: data.url,
        tab: null,
        type: dialogData.type,
        bgColor: dialogData.bgColor,
        hoverColor: dialogData.hoverColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);

      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };

  const textLinkStep = {
    title: "Animated Button",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "text",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add Button",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(initialStep);
      }
    },
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getAnimatedButtonTemplate({
        text: data.text,
        url: data.url,
        tab: data.openLink,
        type: dialogData.type,
        bgColor: dialogData.bgColor,
        hoverColor: dialogData.hoverColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);

      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };

  tinymce.activeEditor.windowManager.open(initialStep);
};

export { animatedButtonConfig };
